<template>
  <div class="comment-parent">
    <p>
      {{store.languages[store.lang]['reviews'] || '用户评价'}}</p>
    <div>
      <div class="comment-info-pan">
        <div ref="commentInfoItem" class="comment-info" :style="{animationName: 'show-comment-' +slideFlag + '-' + thisindex}">
          <div  class="comment-info-item" v-for="comment in commentList" :key="comment.account">
            <div>
              <div>
                <div class="comment-info-item-tar">
                  <img :src="comment.head"/>
                </div>
                <div>
                  <p>{{comment.account}}</p>
                  <span class="from-lang">来自 {{comment.from}}</span>
                </div>
              </div>
              <div class="comment-stars">
                <img v-for="index of (comment.star)" :key="index" class="star-img"
                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAqCAMAAAAQwSIQAAAAjVBMVEUAAAD/vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg//vg+caxKyAAAALnRSTlMA3wLPCwcX+Ovj1H1CEfDc2MeUbGpcPDAUuqF2Z2NPKvLAsq2oSDclH+eah4RW24XdVgAAASNJREFUOMuV1ddygzAQQFGJbjCEjumusdP2/z8vClYwCSuz3Ec4w7A7jGBoRs1WlMHrCs0hWvNogJysHaFdKk7gpwsNa/tBc5r24F5GwaYt9RtFf8BvzTI2YCxY1jE8qpewD5PsheX1R5j2ftVwaOVpfNjA/3gZN/luOlfx5Z1CG9TZ7tnrelNYjztAy+Epy4FcUIgtcCLWxcRkrptsaMepGOc4HvmGjkXWc+4KTOauwRjCqVjwUIF1gyEVCm0xrK1C96iuFTpDdaXQHqojha4wrDkKHWH6Boocjb4S0Q0/WR8FMGn7/NiJOj/hMNYiugTZoRuGTl5A9oloebO8jEtK5aXTHPs2iI5/3/HudXwl5/l/rwkBYP4RtkFVMKw23F+Z7BsmTZQo/7MF/wAAAABJRU5ErkJggg=="/>
                <img v-for="index of (5 - comment.star)" :key="index" class="star-img"
                     src="data:image/png;base64,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"/>
              </div>
            </div>
            <div>{{comment.content}}</div>
          </div>

        </div>
      </div>
      <div class="buttons but">
        <span class="butspan" v-for="(value,index) of commentList.length " :key="index"
              :class="{themecolor: index === thisindex}" @click="point(index)">
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  import { reactive, ref, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import utils from "../utils/utils"
  import {getDomain} from "@/config";

  export default {
    name: 'Comment',
    components: {},
    setup () {
      let store = useStore().state

      let slideFlag = ref('reight')
      let thisindex = ref(0)
      let commentList = reactive([
        {
          'account': 'Poeut',
          'star': 5,
          'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAaAAACAwEBAAAAAAAAAAAAAAADBQIEBwAG/9oACAEBAAAAANdU5Rz31b61nCt0z80NTUcQkENTmNgAAxG0iEYo/wD/xAAYAQEBAAMAAAAAAAAAAAAAAAACAAEDBP/aAAgBAhAAAAAbcdiLr//EABgBAQEAAwAAAAAAAAAAAAAAAAIAAQME/9oACAEDEAAAAFruUI2P/8QAJxAAAgEEAQQCAQUAAAAAAAAAAQIDAAQRMQUQEiFBEyIUFSNRYZH/2gAIAQEAAT8AnseMULbPaqFfTBfY9Gv0x+Ks7qSJ8rtUq7lmllZm3mre1kfyGXVWtlD3JmTyfVD5YIsLsjVW3NWEzsfCvnPad+KmeK8+siAoy4xndc3BYQXItVcA7ONKDqvjt07Px5Fyd+a4+3RJoGeQZbyMHdX98ouo47fAYt2tScnJGJFSKP7grlh9sH+6TlLyGMRxylVBJq4kklcySOXY+yaFWVzHCrStIQ+gAPNQ3L3XJ2xZnOXA+u6+M7pt04o9ONuUtZxMV0jf6aaQn3qmNTd/Z+3jORv+OhxiiayKY4FHoen/xAAZEQEBAQEBAQAAAAAAAAAAAAABEQACIDH/2gAIAQIBAT8AjgZo2GeecGeSKffH/8QAGxEAAwACAwAAAAAAAAAAAAAAAAERAiESIDH/2gAIAQMBAT8A0N42FUObLuie0n50/9k=',
          'content': '线路多,速度快,看NETFIX很方便,而且客服回复速度也很快,偶尔有点小问题很快就能解决用了很久了,一直很稳定。',
          'date': '2021年5月28日'
        },
        {
          'account': 'dusan peil',
          'star': 5,
          'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAaAAEBAQEAAwAAAAAAAAAAAAAHBgUDAgQI/9oACAEBAAAAAHuHDfBXVZgAl0/skwgrffQJ5x9wEQXWSy+4qpb9Fsahec0Nci//xAAWAQEBAQAAAAAAAAAAAAAAAAABAgP/2gAIAQIQAAAAqVw0sP/EABYBAQEBAAAAAAAAAAAAAAAAAAEDAP/aAAgBAxAAAACbis8n/8QAMxAAAQMDAgMECAcBAAAAAAAAAgEDBAAFEQYSBxMiITFBYRQVMjNCUVKyEDRDU3OCwdL/2gAIAQEAAT8AJREVJVRESr/q9q3xX32s7A+PGVJV8BSp+ttRznjL1g603+00XYlRdZ6oie6ujpfyddaP4hesy9EuQCElBzvDuKhISRCRcotX+aX5YV6U6nP8StX3ZJk4YrRZaj5z8icphlyQ+yw17x1wQDPd1Lii0ukaLqRlltDVXWo8Yk6878IKj/Za1jYxs8S2XqDgHorvoz4/NEzsVa0zdEeAGs9DjaOM580ziuIF2kQmSbYXDkl40U/EQT5VhErh7alnXk30LCxGlND83MjUBiUywgSpKPmhe3sQftriMzJCwzHXX2zA5DPLDYKY6q0tK3xbQ8C5wLYr9qpWsrXap7RxpdxjxJIGrjBumiU+yUd9xkjbMgLbls94F5iqeFcNbhIjXSUw3DekMvAG8mv0iT2d1T5T8YB5UJx9V+lUTGK1daD1CxAtvPOL1LINeVzU6BxsPCp9daZ03PsqRYUt0TIpSkmz2cJXEbTbsgAvEUMuMhsfFPEB+KiASTqFFrRepLYFses90JloMKjZHgWzAu8SrQUmfIj3Np+6OTGIz6NRnTHqUPNan6gtFumR4DrmZDxiiNjlcb17N6+GaitEZ85wRTs6ETz71pK1Bw6jTDOTbHBjul2k0Xui/wCakaK1OwWFthmn1NEJpWmoWu7TGOHAtQNtuvK6bkjvyuB8Tq16JzcSu17fCTLI0c2Am1sTT8P/xAAbEQEBAAIDAQAAAAAAAAAAAAABAAIxAxEhcf/aAAgBAgEBPwADqUgE7J9PLPdxu/kJpssCMQL/xAAZEQEBAQEBAQAAAAAAAAAAAAABABECIQP/2gAIAQMBAT8AevcLCXG5D3bnnb6DsjukdJkq3//Z',
          'content': '冲鸭, 冲呀, 这个名字一听就很快!',
          'date': '2021年5月14日'
        },
        {
          'account': '小王子呀',
          'star': 5,
          'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAbAAACAgMBAAAAAAAAAAAAAAAFBgMEAAIHAf/aAAgBAQAAAABnYpw7Tb57J7QJkAV/AZ84iLohyWH8WU1V3WvYOb87ZYf/xAAXAQEBAQEAAAAAAAAAAAAAAAACAAMB/9oACAECEAAAAMX0TzV//8QAFwEAAwEAAAAAAAAAAAAAAAAAAQIDBP/aAAgBAxAAAADYs6qGA//EACwQAAIBAwMDAgYCAwAAAAAAAAECAwAEEQUSIRNBUTFhFBUiM0JScaGxweH/2gAIAQEAAT8A027ubc7RK5wcOG9uDS6rKqbjJ/Gf8NQ1sx7TLFuT90NSTWtzfMxM6oSjMhUZJ8cEGo9StmHGQP48V8TBjPVFT38JvZFWNeTncR3NbOsVZkx/vFXIljXMcmxVkXfkdhSWhj1NJDKSzkMDnz2pZZ5nljLjGTh1/HFW1sy+GPkmooU+5OwGXzyfFGWHtKoz7+KkmgeWBl+rLclTxVzc9C/hjXlOs3/BWnxKkFooPLR7nz3c96iZUdWYfSPXjsa6LxlpLhQ7dkPoAa1Xqyo7WsYEu0q6cDcp/UmtBg1Wyv7YzRyRwuWV898+1JbCScMX7t6+vNX+t6vFqrQwmSK2RykSKv3AvGc981pt5em2h+JuB1eGdMDv2pEvblhJIoEhXjYT347kiotHn2LujRvXPOSc0lonVaGWPYccZHmofmC6g9icCffkccbTznP618tRkCBWCjwcDNW0CLOIkTbH+fGMnxWmyxTs4j9BSzdNAD6CpNtzCynuOD4PmrFNb+MaabY2RjjjgUsF9Py0vSB7IPHvR0eaNy0NxKG8lt/9Gv/EABkRAAMAAwAAAAAAAAAAAAAAAAABEQIhMf/aAAgBAgEBPwDCpQrFkxdOM2jVJEJM/8QAHBEBAAICAwEAAAAAAAAAAAAAAQACETEDEBIi/9oACAEDAQE/AOTzZykotH5cRoO46h0qOJWwbjYn/9k=',
          'content': '速度很快, 且稳定, 大大的赞',
          'date': '2021年3月1日'
        },
        {
          'account': '六六六',
          'star': 5,
          'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAbAAACAwADAAAAAAAAAAAAAAADBgQFBwACCP/aAAgBAQAAAADXUTrKYLMPn9ntgaxBXVusatCjVi7y9Yo6iIx2UOXXhFzU/wD/xAAWAQEBAQAAAAAAAAAAAAAAAAAEBQb/2gAIAQIQAAAAl2s+pwhUQf/EABgBAAMBAQAAAAAAAAAAAAAAAAMEBgIF/9oACAEDEAAAANR9qAo+gsz/AP/EADEQAAICAAQFAgUBCQAAAAAAAAECAwQABRESBhMhIjEUkTJBQlFhFRYjUmJyoaKx8f/aAAgBAQABPwDYPsMcU8XrlBihoRRTz7/328diLht96OCzPdl7wrDlSNHH3DwqriBMxr2k9LYklJBPpp21VwP4WOpTGU5rRzeKR6+okicxzQuNHiceVbBQfYe2LkjwUrMydHWJtn9R8YzuKUTalCKoniimk8nV/wDegGM1mt1HqU6EaSJXWKRO7UsV8bjivnckubUZYK0scXLePR9OjnuPtpjgy69rP7dwOTHcnn6/fyV/suJBjMQPQSflox7uBivw7leapmFO2WO2zHOOW+1lJTaNcWeGZaBeKSSq0p3su0tu5Y8FvfEXD962IkaeKBOYQ7mTY20dGMbAtroMZDRqwXqnpoDDF6uTlxEMCiLCyKDu666DriQYlhM1aWMOFZkOjEa7W8g6fjFyvdShyIrCw2HnAjkB03f9x6fPhMjz161wxtuB5iKwI7vj1VsS184NkWFyaASBFG6ScE9OmvR1XGWVr8lqOa6sKSpK7lYv5k0Hj5ndriTAkCIWY6Ko1JwOJK2bxGeomw0rCTbZm2cxSCvTzhOLaKa83LHUbfol16Dt/GP2vyr4YcunY/YtiPiihUptfsxNGtixsREPMOioFws8ViKOaJw0ciBlI+oN1Bwx0XqNdfliTg2/+qMkCIKXMEgd+o0H06eemumK/BSRGvraB2QQRydnxtHJzGOH4NMlm3NJcUc0FU2p3xqX3dCT1IHTEnCGaJLl9EKHrIBvnX/I6E+2IY44YYoY1CpGgVQPkF6AY//EACIRAAEDAwMFAAAAAAAAAAAAAAEAAwQCERITMWEFIjJRUv/aAAgBAgEBPwDp8RpwVuO+I2HKqDdTengLKbE0axY3BF1FcAZw9oEDfNTK8yOBZRnQD3FCTR9qS8CTY3X/xAAkEQACAQQCAAcBAAAAAAAAAAABAgQAAxIhEUEFIlFSYXFykf/aAAgBAwEBPwCVNdZNqPbHJZSzfAFW4HiyXRNEu5jkTifbUOYL6trgqcT91cjgzFvc7wxpkk7QNYK/rjVQ4wjG6Muc3Lf2mQEMe+qCrhux5vTLVC2Aqnvuv//Z',
          'content': '比我想象中的要快很多, 连接后嗖嗖嗖的! 5星好评',
          'date': '2021年6月1日'
        },
        {
          'account': 'Bored lol',
          'star': 5,
          'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAbAAACAgMBAAAAAAAAAAAAAAAEBgMFAQIHAP/aAAgBAQAAAADtWdRqVw5rK2+BY11aZpKk3dUcLVfuwkrBNQ1wc6OliG//xAAWAQEBAQAAAAAAAAAAAAAAAAABAgD/2gAIAQIQAAAAo1y2v//EABYBAAMAAAAAAAAAAAAAAAAAAAABAv/aAAgBAxAAAAAYyZUf/8QAMxAAAgECBQIDBgQHAAAAAAAAAQIDBBEABRITISIxBhRCQVFhYnGRBxWBsSNSU6GywdL/2gAIAQEAAT8Au6PpXlMTTatyOJjqHBb2C/8AvA3la6FBfutie/1JxmVdWUVI88NC1Uw7pGbGw9oBxkFZnVXmM0lfMFUU2ry6jiPW3Tf48HHN1bt8PrjOJfEa5tNSwZrtRODJTfw05SwDLqt3UnHhiHPYamo/M6l3jRNEUQfWD6i+EqRuyKV5I1cm3c6cGokR+prB24+U4kn/AC6eorA8CiWNFYSsUUGO/q5sDq92IpDPTQylGTWqtpPsuL2x4lplnyyOIXWTeGyVOgiSxsQf8vlx4UzCprKOM1UqNOWbrUaQygab/wDQxvUe/HE0gFVIbxRDlmAuT2vx3xV0tVNGkQAKyERyMeCvzAWPWPscb9Q9KS8AmJRCNwcEjpfsp+uKePMlaGKgheChc86tAaK3tiQmwQ48TxQS0NJDI+iR6oaHHcAA67fVLjFHGlJU1bBzrpqjUYbjgT9Wpf04HxxDsirWYbYMvVrvbVbj9sVNbBTwtIXBPsUHkn3YoQ7yojNxEQx4uDrv/YYoa7eR1I4WVwh964zuWj2nWoRHZWi2g39Q9Vx9sZlFFN5nVaWRWj3WDGMggXaxFivcYy2SaSm8vP5gqV6DErPLGYxpu1uRb98VEOYxIgWs1hwCswphp56eTqN7/vjzlfS5rSUElRHvmTkx3UORZiOb4qKKnzNRBWV9VSVJF0VH27k+pP5sZu6ZhWakn0bReHWPTqFi/wBB2xqh8KZtBu1kconZ966mQlZeGOMt8SZZDUVQpK2tgWWTlECXdgvpV0LfpfGc+J6rLqyDy8+5DXATIVcqrBvV6QCcZpRylKKqpqpgkE8k0zxEXhiEWq63vwR9icZr+IObVcE0EVJFBTyjQGJ1uARbptpx/8QAHREAAwABBQEAAAAAAAAAAAAAAAERIQMQEiIyUf/aAAgBAgEBPwCYt3XkzUkNMSiouVqNTvJ8P//EABoRAQEBAAMBAAAAAAAAAAAAAAEAEQISIVH/2gAIAQMBAT8AxsmLcFWUbt7kngOtwU05ffL/2Q==',
          'content': '个人比较看好的一家, 服务质量很棒, 我是指速度 XD',
          'date': '2021年3月24日'
        },
        {
          'account': 'Gmed',
          'star': 5,
          'head': 'data:image/jpg;base64,/9j/4AAQSkZJRgABAQIAJQAlAAD/2wCEAAgICAgJCAkKCgkNDgwODRMREBARExwUFhQWFBwrGx8bGx8bKyYuJSMlLiZENS8vNUROQj5CTl9VVV93cXecnNEBCAgICAkICQoKCQ0ODA4NExEQEBETHBQWFBYUHCsbHxsbHxsrJi4lIyUuJkQ1Ly81RE5CPkJOX1VVX3dxd5yc0f/CABEIADAAMAMBIgACEQEDEQH/xAAaAAACAwEBAAAAAAAAAAAAAAAFBwMEBgII/9oACAEBAAAAAFI9LayXpmP0rPiU2D2zwupbJDNY4TKIFCbDBYHnzgnmjG8WPcH/xAAXAQADAQAAAAAAAAAAAAAAAAADBAUB/9oACAECEAAAAMUrpgrDAz//xAAWAQEBAQAAAAAAAAAAAAAAAAADBAX/2gAIAQMQAAAAanPZYmWT/8QAMhAAAQMCBAMECQUAAAAAAAAAAQIDBAASBRETIQZBQhQiMZEHMlFTcXKBgqFSYWKSov/aAAgBAQABPwCfi+KYoVl+QQgAnTR3UeVT48OdhscMNraVHZaSHynuug8kg+skEVhBgIYsRCcBHrLAvuI57b16SGkDG41oyHYwfDLrVSFusG9pxaFe1JyqNxNPj5B5Db6f3FqvMUxFubdHtSlP9jlWKm/DIjZ8Dl5AVhaE9jatSAMuQriSQwnFtMupS7pNH7SsgHzrFuzGe+Y4Abu8ALQCNjtTiBnTLQSDt4aX4cFTlkxYg5FqsE3jLSeldekJ8Hidzuhemwyneo70NbmT7EZpATsSH1jP6LJqVZrOaaklGe1oIG/svzNLWDqpSrMLaNp/0KiT+14NhzyV53M5GsCIsk/MK4rKZXFuJhUhLSNYDVWCQkIQB0A069hEVJERpyY976QmxoH+DW+f3H6VOZfZkrQ/us97MdV3Oo0hWihXu12/SuEcSuYkwyrZo3I+CqwqUWnpCSQEaN5UekJqZLMuZJlKzzeeW5uf1m6oSA/OjM55BTqa4qW32qOlOVwaN2QplakJWoeGwIrCMSMKc270Hur+BrEseQxAm6R3fiFsH5lBJ/BouVBlCPMjvK9VC6mTHJkhx9zZSuQ5ZV//xAAgEQACAgIBBQEAAAAAAAAAAAABAgADBBEhBRITQVFh/9oACAECAQE/AM0KioqjUx7Ctuwu+IVW1QWE6gDpDMAbtb8E3MmvyUmYNXarMfcbmwfAJ//EAB8RAQACAgICAwAAAAAAAAAAAAEAAgMEETESIjNhcf/aAAgBAwEBPwDUVyj9y2Iy5bVbePLEaXQemaHyTa9bv7GaljHmr5dczfUzMOp//9k=',
          'content': '亲测可以用, 推荐一波',
          'date': '2021年4月26日'
        }
      ])

      function getComment () {
        this.$http.get(`${getDomain('oc')}/api/website/vue/comment`)
          .then((data) => {
            let _data = data.data.obj
            commentList.length = 0
            if (_data) {
              _data.forEach(d => {
                commentList.push(d)
              })
            }

          })
          .catch(e => {
            console.log(e)
          })
      }

      function point (index) {
        const _index = index - thisindex.value
        slideFlag.value = _index > 0 ? 'right' : 'left'
        thisindex.value = index
      }

      let commentInfoItem = ref(null)

      function itemEvent (dom) {
        utils.bindSwiperEvent(dom,
          function () {
            if (thisindex.value < commentList.length - 1) {
              thisindex.value++
              slideFlag.value = 'right'
            }
          },
          function () {
            if (thisindex.value > 0) {
              thisindex.value--
              slideFlag.value = 'left'
            }
          })
      }
      onMounted(()=>{
        itemEvent(commentInfoItem.value)
      })
      return {
        commentInfoItem,
        slideFlag,
        thisindex,
        commentList,
        getComment,
        store,
        point
      }
    },
    created () {
      this.getComment()
    }
  }
</script>

<style>

  .comment-parent {
    width: 75%;
    margin-left: 12.5%;
    margin-right: 12.5%;
    margin-top: 3rem;
    font-family: 'Roboto', sans-serif;
  }

  .comment-parent span {
    font-weight: 400;
  }

  .comment-parent > p {
    margin-bottom: .5rem;
    font-size: 2rem;
    font-weight: 800;
    line-height: 5rem;
    text-align: center;
    color: #262626;
  }

  .comment-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 100%;
  }

  .comment-info-item p {
    color: #000000;
    font-weight: 900;
    font-size: 1.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .comment-info-item {
    min-height: 20rem;
    width: 32%;
    padding: 1.2rem;
    margin-bottom: 3.2rem;
    border-radius: 6px;
    border: 1px solid #E0E0E0;
    font-size: 1.2rem;
    line-height: 2rem;
    font-weight: 500;
    color: #7F7F7F;
    box-sizing: border-box;
  }

  .comment-info-item > div:nth-child(1) {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 1.2rem;
  }

  .comment-info-item > div > div:nth-child(1) {
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
  }

  .comment-info-item > div > div > div:nth-child(2) {
    margin-left: 1rem;
  }

  .comment-info-item-tar {
    height: 50px;
    width: 50px;
  }

  .comment-info-item-tar img {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 1px solid #E0E0E0;
    box-shadow: 0 2px 4px 0 rgb(0 0 0 / 6%);
  }

  .comment-stars {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-end;
    width: 6.1rem;
    height: 2rem;
    align-items: center;
  }

  .comment-stars img {
    height: 1.2rem;
  }

  .comment-parent > div {
    position: relative;
  }

  .buttons {
    position: absolute;
    height: 0.13333rem;
    bottom: -1.3333rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1;
    display: block;
  }


  .buttons span {
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #E0E0E0;
    margin-right: 4px;
  }


  @keyframes show-comment-right-0 {
    0% {

    }
    100% {
      transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
    }
  }

  @keyframes show-comment-right-1 {
    0% {
      transform: translateX(0);
      -ms-transform: translateX(0);
      -webkit-transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }

  @keyframes show-comment-right-2 {
    0% {
      transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
    100% {
      transform: translateX(-200%);
      -ms-transform: translateX(-200%);
      -webkit-transform: translateX(-200%);
    }
  }

  @keyframes show-comment-right-3 {
    0% {
      transform: translateX(-200%);
      -ms-transform: translateX(-200%);
      -webkit-transform: translateX(-200%);
    }
    100% {
      transform: translateX(-300%);
      -ms-transform: translateX(-300%);
      -webkit-transform: translateX(-300%);
    }
  }

  @keyframes show-comment-right-4 {
    0% {
      transform: translateX(-300%);
      -ms-transform: translateX(-300%);
      -webkit-transform: translateX(-300%);
    }
    100% {
      transform: translateX(-400%);
      -ms-transform: translateX(-400%);
      -webkit-transform: translateX(-400%);
    }
  }

  @keyframes show-comment-right-5 {
    0% {
      transform: translateX(-400%);
      -ms-transform: translateX(-400%);
      -webkit-transform: translateX(-400%);
    }
    100% {
      transform: translateX(-500%);
      -ms-transform: translateX(-500%);
      -webkit-transform: translateX(-500%);
    }
  }


  @keyframes show-comment-left-0 {
    0% {
      transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
    100% {

    }
  }

  @keyframes show-comment-left-1 {
    0% {
      transform: translateX(-200%);
      -ms-transform: translateX(-200%);
      -webkit-transform: translateX(-200%);
    }
    100% {
      transform: translateX(-100%);
      -ms-transform: translateX(-100%);
      -webkit-transform: translateX(-100%);
    }
  }

  @keyframes show-comment-left-2 {
    0% {
      transform: translateX(-300%);
      -ms-transform: translateX(-300%);
      -webkit-transform: translateX(-300%);
    }
    100% {
      transform: translateX(-200%);
      -ms-transform: translateX(-200%);
      -webkit-transform: translateX(-200%);
    }
  }

  @keyframes show-comment-left-3 {
    0% {
      transform: translateX(-400%);
      -ms-transform: translateX(-400%);
      -webkit-transform: translateX(-400%);
    }
    100% {
      transform: translateX(-300%);
      -ms-transform: translateX(-300%);
      -webkit-transform: translateX(-300%);
    }
  }

  @keyframes show-comment-left-4 {
    0% {
      transform: translateX(-500%);
      -ms-transform: translateX(-500%);
      -webkit-transform: translateX(-500%);
    }
    100% {
      transform: translateX(-400%);
      -ms-transform: translateX(-400%);
      -webkit-transform: translateX(-400%);
    }
  }

  @keyframes show-comment-left-5 {
    0% {
      transform: translateX(-500%);
      -ms-transform: translateX(-500%);
      -webkit-transform: translateX(-500%)
    }
    100% {
      transform: translateX(-500%);
      -ms-transform: translateX(-500%);
      -webkit-transform: translateX(-500%);
    }
  }

  .buttons .themecolor {
    background-color: #000000 !important;
  }


  @media all and (max-width: 366px) and (min-width: 150px) {

    .comment-info-pan {
      overflow: hidden;
    }

    .comment-info {
      display: inline-block;
      white-space: nowrap;
      animation: show-comment-right-0 0.5s ease 0s forwards normal;
    }

    .comment-info-item {
      display: inline-table;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      margin-bottom: 0;

    }

    .comment-parent {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }

    .comment-info-item > div:first-child {
      height: 6.3rem;
    }

    .comment-info-item > div:last-child {
      white-space: normal;
    }

    .comment-info-item p {
      font-size: 1.2rem;
      width: 9rem;
    }

    .comment-info-item {
      font-size: 1rem;
      height: 25rem;
    }

  }

  @media all and (max-width: 500.999px) and (min-width: 366px) {

    .comment-info-pan {
      overflow: hidden;
    }

    .comment-info {
      display: inline-block;
      white-space: nowrap;
      animation: show-comment-right-0 0.5s ease 0s forwards normal;
    }

    .comment-info-item {
      display: inline-table;
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
      margin-bottom: 0;
      height: 24rem;

    }

    .comment-info-item p {
      width: 11rem;
    }

    .comment-parent {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
    }

    .comment-info-item > div:last-child {
      white-space: normal;
    }
  }


  @media all and (max-width: 800px) and (min-width: 501px) {

    .comment-info-pan {
      overflow: hidden;
    }

    .comment-info {
      display: inline-block;
      white-space: nowrap;
      animation: show-comment-right-0 0.5s ease 0s forwards normal;
    }

    .comment-info-item {
      display: inline-table;
      width: 80%;
      margin-left: 10%;
      margin-right: 10%;
      margin-bottom: 0;

    }

    .comment-parent {
      width: 90%;
      margin-left: 5%;
      margin-right: 5%;
    }

    .comment-info-item p {
      width: 11rem;
    }

    .comment-info-item > div:last-child {
      white-space: normal;
    }
  }

  @media all and (max-width: 1399px) and (min-width: 800.9px) {

    .comment-info-item {
      width: 47%;
      display: block !important;
    }

    .comment-info-item p {
      width: 11rem;
    }

    .buttons {
      display: none;
    }
  }


  @media all and (max-width: 1600px) and (min-width: 1400px) {
    .comment-info-item {
      width: 32%;
      display: block !important;
    }

    .comment-info-item p {
      width: 14rem;
    }

    .buttons {
      display: none;
    }
  }

  @media all and (max-width: 2100px) and (min-width: 1601px) {

    .comment-info-item {
      height: 20rem;
      width: 32%;
      display: block !important;
    }

    .comment-info-item p {
      width: 17rem;
    }

    .buttons {
      display: none;
    }
  }

  @media all and (min-width: 2101px) {

    .comment-info-item {
      height: 20rem;
      width: 32%;
      display: block !important;
    }

    .comment-info-item p {
      width: 19rem;
    }

    .buttons {
      display: none;
    }
  }

</style>
